import { Component, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { IComando, IFilter, IPopulate, IQueryParam } from 'modelos/src';
import { Subscription } from 'rxjs';

import { MatDialog } from '@angular/material/dialog';

import { HelperService } from '../../../../../../auxiliares/servicios/helper.service';
import {
  IFiltroTabla,
  IRegExpSearch,
} from '../../../../../../auxiliares/tabla/filtro/filtro.component';
import { IColumnas } from '../../../../../../auxiliares/tabla/tabla.component';
import { AuxiliaresModule } from '../../../../../../auxiliares/auxiliares.module';
import { DialogService } from '../../../../../../auxiliares/dialog/dialog.service';
import { ComandosService } from '../../../../../../auxiliares/servicios/http/comandos.service';
import { Lista2Service } from '../../../../../../auxiliares/servicios/lista2.service';
import { LuminariasService } from '../../../service';
import { nivelPerfil } from '../../../../../../auxiliares/iconos/iconos';

@Component({
  imports: [AuxiliaresModule],
  selector: 'app-listado-comandos-historico',
  templateUrl: './listado-comandos-historico.component.html',
  styleUrl: './listado-comandos-historico.component.scss',
})
export class ListadoComandosHistoricoComponent implements OnInit, OnDestroy {
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  dialog = inject(MatDialog);
  private dialogService = inject(DialogService);
  private comandosService = inject(ComandosService);
  private luminariasService = inject(LuminariasService);

  public loading = false;
  //// Tabla nueva
  @Input() public id: string = null;
  @Input() public deveui: string = null;
  @Input() public tipo: 'Luminaria' | 'Cliente';

  public name = 'ListadoComandosHistoricoComponent';
  public comandosHistorico?: IComando[];
  public comandosHistorico$?: Subscription;
  public totalCount = 0;
  public columnas?: IColumnas<IComando>[];

  //FILTROS

  public search: IRegExpSearch = {
    fields: ['cliente'],
  };

  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };

  private fecha: IFiltroTabla = {
    filter: {
      field: 'fechaCreacion',
    },
    label: 'Fecha',
    tipo: 'dateRange',
  };
  public filtros: IFiltroTabla[] = [this.fecha, this.cliente, this.ancestro];
  public populate: IPopulate[] = [
    {
      path: 'usuario',
      select: 'usuario datosPersonales',
    },
  ];
  // QUERY
  public query: IQueryParam = {
    sort: '-fechaCreacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    populate: JSON.stringify(this.populate),
    includeChildren: true,
    childrenLevel: 0,
  };

  public async eliminar(comando: IComando) {
    const res = await this.dialogService.confirm(
      'Confirmá la acción',
      '¿Querés eliminar el comando?',
    );
    if (!res) return;
    try {
      await this.comandosService.delete(comando._id!);
      this.helper.notifSuccess('Eliminado correctamente');
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  //LISTADO
  public async listar(): Promise<void> {
    let filter: IFilter<IComando>;
    if (this.query.filter) filter = JSON.parse(this.query.filter);
    else filter = {};
    if (this.tipo === 'Luminaria') filter.deveui = this.deveui;
    if (this.tipo === 'Cliente') filter.idCliente = this.id;

    this.query.filter = JSON.stringify(filter);
    this.loading = true;
    this.comandosHistorico$?.unsubscribe();
    this.comandosHistorico$ = this.lista2
      .comandos(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.comandosHistorico = data.datos;
        this.loading = false;
      });
  }

  private setColumnas() {
    const columnas: IColumnas<IComando>[] = [
      // Fecha Creación
      {
        header: {
          label: 'Fecha de creación',
          sort: 'fechaCreacion',
          sortable: true,
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          hace: true,
          noData: 'Sin fecha',
        },
      },
      //Usuario
      {
        header: {
          label: 'Usuario',
        },
        row: {
          parse: (dato) => {
            if (dato?.usuario) {
              const usuario = dato.usuario;
              const nombrePersonal = usuario.datosPersonales?.nombre;
              const nombreUsuario = usuario.usuario;

              // Si tiene nombre personal, primero el nombre y luego el usuario entre paréntesis
              if (nombrePersonal && nombreUsuario) {
                return `${nombrePersonal} (${nombreUsuario})`;
              }
              // Si solo tiene nombre personal
              else if (nombrePersonal) {
                return nombrePersonal;
              }
              // Si solo tiene usuario, sin paréntesis
              else if (nombreUsuario) {
                return nombreUsuario;
              }

              return '';
            } else {
              return '';
            }
          },
          noData: 'Sin usuario',
        },
      },
      //nombre
      {
        header: {
          label: 'Descripción',
        },
        row: {
          field: 'descripcion',
          noData: 'Sin descripción',
        },
      },
      //Payload
      {
        header: {
          label: 'Payload',
        },
        row: {
          field: 'payload',
          claseCss: () => 'tabla-codigo',
          noData: 'Sin payload',
        },
      },
      //Estado
      {
        header: {
          label: 'Estado',
        },
        row: {
          // Mismo nombre, ícono y tono que el último comando del listado
          estado: (dato) =>
            dato?.estado
              ? this.luminariasService.estadoComandoCelda(dato.estado)
              : undefined,
          noData: 'Sin estado',
        },
      },

      //Puerto
      {
        header: {
          label: 'Puerto',
        },
        row: {
          field: 'puerto',
          noData: 'Sin puerto',
        },
      },

      {
        header: {
          label: 'FCnt',
        },
        row: {
          field: 'fCnt',
          noData: 'Sin FCnt',
        },
      },

      //Origen (objetivo: desde qué nivel/entidad se envió el comando)
      {
        header: {
          label: 'Origen',
        },
        row: {
          parse: (dato) => {
            const obj = dato?.objetivo;
            if (!obj) return '';
            const nivel = nivelPerfil(obj.nivel).label;
            return obj.nombre ? `${nivel}: ${obj.nombre}` : nivel;
          },
          noData: 'Sin origen',
        },
      },
    ];

    // Acciones
    columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () => !this.helper.tienePermiso('Luminarias - Enviar comandos'),
          },
        ],
      },
    });

    this.columnas = columnas;
  }

  // Hooks

  async ngOnInit() {
    this.setColumnas();
    Promise.all([this.listar()]);
  }

  async ngOnDestroy() {
    this.comandosHistorico$?.unsubscribe();
  }
}
